import { useSelector } from "react-redux";

const Modal = ({ isOpen, onSubmit, onClose }) => {
  const data = useSelector(
    (state) => state.test.questionSummary?.questionsInfo
  );

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-50"></div>}

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h2 className="text-xl font-bold mb-4">Exam Summary</h2>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col bg-gray-100 p-4 rounded-md">
                <span className="font-bold">Answered</span>
                <span className="text-green-500 text-lg">
                  {data?.filter((x) => x?.status === "answered")?.length}
                </span>
              </div>
              <div className="flex flex-col bg-gray-100 p-4 rounded-md">
                <span className="font-bold">Marked for Review</span>
                <span className="text-yellow-500 text-lg">
                  {data?.filter((x) => x?.status === "markedForReview")?.length}
                </span>
              </div>
              <div className="flex flex-col bg-gray-100 p-4 rounded-md">
                <span className="font-bold">Not Answered</span>
                <span className="text-red-500 text-lg">
                  {data?.filter((x) => x?.status === "notAnswered")?.length +
                    data?.filter((x) => x?.status === "")?.length}
                </span>
              </div>
              <div className="flex flex-col bg-gray-100 p-4 rounded-md">
                <span className="font-bold">Answered & Marked for Review</span>
                <span className="text-blue-500 text-lg">
                  {data?.filter((x) => x?.status === "saveAndMark")?.length}
                </span>
              </div>
            </div>
            <div className="flex justify-center mt-10 gap-5">
              <button
                className="py-2 px-4 flex items-center border bg-rose-500 uppercase rounded text-white font-bold text-xl hover:bg-rose-600"
                onClick={onClose}
              >
                Close
              </button>
              <button
                onClick={onSubmit}
                className="py-2 px-4 flex items-center border bg-cyan-600 uppercase rounded text-white font-bold text-xl hover:bg-cyan-700"
                style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
